import * as React from 'react'
import styled, { css } from 'styled-components'
import { brandGroups } from './data'

import * as plume from '@ulule/owl-kit-components/next'
import { INTERMEDIATE_BREAKPOINT } from '@ulule/header/src/components/style'

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

const usedLetters = brandGroups.map((brandGroup) => brandGroup.key)

export function Nav(): React.ReactElement {
  return (
    <Wrapper>
      <LetterList>
        <li>
          <LetterLink href="#sharp">
            <plume.styles.copy.L>#</plume.styles.copy.L>
          </LetterLink>
        </li>
        {alphabet.map((letter) => {
          const isDisabled = !usedLetters.includes(letter)

          return (
            <li key={letter}>
              <LetterLink href={`#${letter}`} disabled={isDisabled}>
                <plume.styles.copy.L>{letter}</plume.styles.copy.L>
              </LetterLink>
            </li>
          )
        })}
      </LetterList>
    </Wrapper>
  )
}

const LetterLink = styled(plume.Link)`
  width: 22px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;

      ${plume.styles.copy.L} {
        opacity: 0.35;
      }
    `}
`

const Wrapper = styled.nav`
  position: sticky;
  margin-bottom: 32px;
  top: 0;
  overflow: auto;

  @media screen and ${INTERMEDIATE_BREAKPOINT} {
    top: ${plume.SIZES.HEADER_SUB_NAV_HEIGHT};
  }
`

const LetterList = styled.ul`
  display: flex;
  margin: 0 auto;
  padding: 10px 0;
  max-width: 806px;
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  overflow: auto;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    justify-content: space-between;
  }
`
